const ENV_LABEL: Record<string, string> = {
  production: "prod",
  staging: "staging",
}

export default function VersionTag() {
  const env = ENV_LABEL[import.meta.env.VITE_APP_ENV ?? ""] ?? "local"
  const sha = (import.meta.env.VITE_COMMIT_SHA ?? "dev").slice(0, 7)

  return (
    <div
      style={{
        position: "fixed",
        bottom: 6,
        right: 8,
        fontSize: 10,
        lineHeight: 1,
        padding: "3px 6px",
        borderRadius: 4,
        opacity: 0.85,
        pointerEvents: "none",
        zIndex: 9999,
        fontFamily: "monospace",
        color: "#fff",
        background: "color-mix(in srgb, var(--sidebar) 85%, transparent)",
        userSelect: "none",
      }}
    >
      {env} · {sha}
    </div>
  )
}
